import { useEffect } from 'react';
import { useChatContext } from '../context/ChatContext';
import { broadcastChannel, syncFromOtherTab } from '../reducers/chat.reducer';

/**
 * Hook para sincronización de chat entre pestañas
 * Escucha cambios en otras pestañas y sincroniza el estado local
 */
export const useChatSync = () => {
  const { dispatch } = useChatContext();

  useEffect(() => {
    // Solo configurar si BroadcastChannel está disponible
    if (!broadcastChannel) {
      console.warn('BroadcastChannel not supported, tab sync disabled');
      return;
    }

    const handleBroadcastMessage = (event) => {
      try {
        const { type, payload, timestamp } = event.data;
        
        // Evitar procesar mensajes muy antiguos (más de 5 segundos)
        const now = Date.now();
        if (now - timestamp > 5000) {
          return;
        }

        switch (type) {
          case 'MESSAGES_UPDATED':
            // Sincronizar mensajes desde otra pestaña
            dispatch(syncFromOtherTab(payload));
            break;
            
          case 'MESSAGES_CLEARED':
            // Limpiar mensajes si se limpiaron en otra pestaña
            dispatch(syncFromOtherTab([]));
            break;
            
          default:
            break;
        }
      } catch (error) {
        console.error('Error processing broadcast message:', error);
      }
    };

    // Configurar listener
    broadcastChannel.addEventListener('message', handleBroadcastMessage);

    // Cleanup
    return () => {
      broadcastChannel.removeEventListener('message', handleBroadcastMessage);
    };
  }, [dispatch]);

  return null; // Este hook no renderiza nada
};

export default useChatSync;
